var config = {
  // layers: "/storage/",
  // templates: "/storage/",
  // images: "/storage/images/",
  // size_charts: "/storage/",
  // product_images: "/storage/products/"
};

var result = [];
var __readyU = false;
var __readyLC = false;
var __tRender = null;

var Editor = {};
Editor.dragging = false;
Editor.triggerEnable = true;
var lastClientX = 0;
var lastClientY = 0;

var _scrollDataX = {};

Editor.onMouseMove = function (event) {
  if (layerComponents == null) return;

  if (Editor.dragging) {
    var canvasDx = event.clientX - lastClientX;
    var canvasDy = event.clientY - lastClientY;

    // convert canvas dx, dy to unscaled product image coordinate system
    var productDx = toPrintImageCoordinateSystem(canvasDx);
    var productDy = toPrintImageCoordinateSystem(canvasDy);

    scope.translateX = parseFloat(scope.translateX) + productDx;
    scope.translateY = parseFloat(scope.translateY) + productDy;
    lastClientX = event.clientX;
    lastClientY = event.clientY;

    activeDocument.documentChanged = true;

    render();
  }
};

Editor.onMouseDown = function (event) {
  if (layerComponents == null) return;
  Editor.dragging = true;
  lastClientX = event.clientX;
  lastClientY = event.clientY;
};

Editor.onMouseUp = function (event) {
  if (layerComponents == null) return;
  Editor.dragging = false;
};

Editor.onToggleSideClick = function (event) {
  activeDocument.documentChanged = true;
  scope.flipHorizontal = !+scope.flipHorizontal;
  render();
  event.preventDefault();
};

Editor.onButtonRotateClick = function (event) {
  activeDocument.documentChanged = true;
  if (scope.flipHorizontal)
    scope.rotationDegrees = (scope.rotationDegrees + 90) % 360;
  else
    scope.rotationDegrees = (scope.rotationDegrees - 90) % 360;
  render();
  event.preventDefault();
};

Editor.onResetTX = function (event) {
  activeDocument.documentChanged = true;
  scope.translateX = 0;
  render();
  event.preventDefault();
};

Editor.onResetTY = function (event) {
  activeDocument.documentChanged = true;
  scope.translateY = 0;
  render();
  event.preventDefault();
};

Editor.onScaleChange = function (event) {
  activeDocument.documentChanged = true;
  scope.scale = Math.max(0.05, event.data.value);
  render();
};

Editor.onScaleMinusClick = function ($event) {
  activeDocument.documentChanged = true;
  $event.preventDefault();
  slider.noUiSlider.set(+slider.noUiSlider.get() - 0.05);
  scope.scale = Math.max(0.05, slider.noUiSlider.get());
  render();
};

Editor.onScalePlusClick = function ($event) {
  activeDocument.documentChanged = true;
  slider.noUiSlider.set(+slider.noUiSlider.get() + 0.05);
  $event.preventDefault();
  scope.scale = Math.max(0.05, slider.noUiSlider.get());
  render();
};

Editor.markupChange = function ($event) {
  var markup = Number($("#MarkupVal input").val());
  var price = Number(activeDocument.selectedVariant.price);

  if (activeDocument.hasBackImage) {
    price += Number(activeDocument.selectedVariant.price_back);
    //$('.js-backSide').show();
    $('#BackPriceInTotalPrice').show();
    $('.BackPriceVal').text(round2(activeDocument.selectedVariant.price_back / activeDocument.rate));
  } else {
    //$('.js-backSide').hide();
    $('#BackPriceInTotalPrice').hide();
    $('.BackPriceVal').text("0");
  }
  $('.itemPriceValue').text(round2(price / activeDocument.rate));

  if (activeDocument.product.isTaxed) {
    $("#TaxVal").text(round2(price * +activeDocument.product.tax / 100 / activeDocument.rate));
    price *= (100 + +activeDocument.product.tax) / 100;
  }

  var retail = price * (100 + markup) / 100;
  var retailConverted = round299(retail / activeDocument.rate);
  var priceConverted = price / activeDocument.rate;

  ///$("#RetailPriceVal").text(round2(retail / activeDocument.rate));
  $("#RetailPriceVal").text(retailConverted);
  //$("#ProfitVal").text(round2((retail - price) / activeDocument.rate));
  $("#ProfitVal").text(round2(retailConverted - priceConverted));

  if ($event)
    activeDocument.documentChanged = true;
};

Editor.showVariantPricingTable = function ($event) {
  $event.preventDefault();

  $("#basic-dialog").modal('show');
  // hide, until data loaded
  $("#basic-dialog .modal-dialog").addClass('hide');
  $("#basic-dialog .modal-body").html("");
  $("#basic-dialog .modal-title").html("Price variants");

  var data = Editor.getProductData();

  //
  showOverlay();
  $.ajax({
    type: "POST",
    url: Editor.pageURL + '/pricing',
    data: {
      //back: activeDocument.hasBothSides ? "1" : "0",
      has_back: +(activeDocument.userData.back.image !== null),
      selected_variants: collectSelectedVariants(),

      user_data: JSON.stringify(activeDocument.userData),
      disable_variants: data.disableVariants,
      user_variants: JSON.stringify(data.userVariants),
      disable_options: JSON.stringify(collectDisableOptionData()),

      markup: $("#MarkupVal input").val()
    },
    dataType: "json",
    success: function (result) {
      hideOverlay();
      if (result.error) {
        showToastErrorMessage(result.error);
        return;
      } else {
        $("#basic-dialog .modal-dialog").removeClass('hide');
        $("#basic-dialog .modal-body").html(result.html);
      }
    },
    error: function (response) {
      console.error("RESULT", response);
      var result = response.responseJSON;
      hideOverlay();
      showToastErrorMessage(errorMessage(result));
      $("#basic-dialog").modal('hide');
    }
  });

};

function getSynced() {

  var pSynced = false;
  var vSynced = false;

  for (var k in activeDocument.userData['front']) {
    if (activeDocument.userData['front'].hasOwnProperty(k) && k == "synced") {
      pSynced = activeDocument.userData['front'][k];
      if (typeof activeDocument.selectedVariant.userData !== "undefined" &&
        typeof activeDocument.selectedVariant.userData['front'][k] !== "undefined") {
        vSynced = activeDocument.selectedVariant.userData['front'][k];
      }
    }
  }
  return pSynced || vSynced;
}

function loadScope() {
  var variantCustomed = false;

  var side = activeDocument.side;
  var synced = getSynced();
  if (side == "back" && synced)
    side = "front";

  for (var k in activeDocument.userData[side]) {
    if (activeDocument.userData[side].hasOwnProperty(k)) {
      scope[k] = activeDocument.userData[side][k];

      if (typeof activeDocument.selectedVariant.userData !== "undefined" &&
        typeof activeDocument.selectedVariant.userData[side][k] !== "undefined") {
        variantCustomed = true;
        scope[k] = activeDocument.selectedVariant.userData[side][k];
      }
    }
  }

  $("#share-all-settings").prop("checked", !variantCustomed);
  $("#sync-back-side").prop("checked", synced);
  if (slider)
    slider.noUiSlider.set(+scope.scale);
  /*
  If true, disable some UIs?
  */
}

function saveScopeSide(shared, side, syncOnly) {
  if (shared) {
    if (typeof activeDocument.selectedVariant['userData'] !== "undefined") {
      activeDocument.documentChanged = true;
      delete activeDocument.selectedVariant['userData'];
    }
    for (var k in activeDocument.userData[side]) {
      if (activeDocument.userData[side].hasOwnProperty(k)) {
        if (activeDocument.userData[side][k] !== scope[k]) {
          activeDocument.documentChanged = true;
        }
        if (!syncOnly)
          activeDocument.userData[side][k] = scope[k];
      }
    }
    activeDocument.userData['front'].synced = scope.synced;
    activeDocument.userData['back'].synced = scope.synced;
  } else {
    // variantCustomed!
    if (typeof activeDocument.selectedVariant.userData === "undefined") {
      activeDocument.documentChanged = true;
      activeDocument.selectedVariant.userData = jQuery.extend(true, {}, activeDocument.userData);
    }
    for (var k in activeDocument.userData[side]) {
      if (activeDocument.userData[side].hasOwnProperty(k)) {
        if (activeDocument.selectedVariant.userData[side][k] !== scope[k]) {
          activeDocument.documentChanged = true;
        }
        if (!syncOnly)
          activeDocument.selectedVariant.userData[side][k] = scope[k];
      }
    }
    activeDocument.selectedVariant.userData['front'].synced = scope.synced;
    activeDocument.selectedVariant.userData['back'].synced = scope.synced;
  }
}

function saveScope(syncOnly) {
  if (scope.synced) {
    saveScopeSide($("#share-all-settings").prop("checked"), "front", syncOnly);
    saveScopeSide($("#share-all-settings").prop("checked"), "back", syncOnly);
  } else {
    saveScopeSide($("#share-all-settings").prop("checked"), activeDocument.side);
  }

  if (activeDocument.variants.length > 1
    && activeDocument.orgSelectedVariantId != activeDocument.selectedVariant.id) {
    activeDocument.documentChanged = true;
  }
  if (activeDocument.product.markup != $("#MarkupVal input").val()) {
    activeDocument.documentChanged = true;
  }
}

Editor.changeSideClick = function ($event) {
  var toSide = $(this).attr("class").indexOf("back") >= 0 ? "back" : "front";
  saveScope();
  showVersion(activeDocument.selectedVariant, toSide);
};

Editor.changeSyncBackSideClick = function ($event) {
  scope.synced = $(this).prop("checked");
  activeDocument.documentChanged = true;
  saveScope(true);
  //if (activeDocument.side === "back")
  showVersion(activeDocument.selectedVariant, activeDocument.side);
};

Editor.changeShareClick = function ($event) {
  if ($(this).prop("checked")) {
    saveScope();
    delete activeDocument.selectedVariant['userData'];
    showVersion(activeDocument.selectedVariant, activeDocument.side);
  }
};

Editor.onShippingTabChange = function () {
  var key = $(this).val();
  $(".shipping-destionation-tabs").hide();
  $("#shipping-destination-" + key).show();
};

Editor.onFileChanged = function (files) {
  Collections.uploadImage(files, Editor.pageURL + '/upload',
    function (result) {
      $("#file-uploader").val('');
      var $container = $('.js-images-list');
      $container.append(
        $('<a></a>').attr('id', 'img' + result.id).css({'background-image': 'url(' + config['images'] + result.preview + ')'}).data('image-id', result.id).data('image-src', result.image).data('image-preview', result.preview)
      );
      replaceImage(result);
    },
    function () {
      $("#file-uploader").val('');
    });
};

Editor.getProductData = function () {
  var data = {
    selected: null,
    disableVariants: [],
    userVariants: {}
  };
  if (+activeDocument.selectedVariant.status) {
    data.selected = activeDocument.selectedVariant.id;
  }
  for (var i = 0; i < activeDocument.variants.length; i++) {
    if (!+activeDocument.variants[i].status) {
      data.disableVariants.push(activeDocument.variants[i].id);
    } else if (typeof selected === "undefined") {
      selected = activeDocument.variants[i].id;
    }
    if (typeof activeDocument.variants[i].userData !== "undefined") {
      data.userVariants[activeDocument.variants[i].id] = activeDocument.variants[i].userData;
    }
  }
  return data;
};

Editor.onDocumentSaved = function () {
  var data = Editor.getProductData();

  showOverlay();
  /** Send ajax on save editor method with prepared data */

  //var useDefaultTitle = $('input[name="use-title-as-default"]').is(':checked');
  //var useDefaultDescription = $('input[name="use-description-as-default"]').is(':checked');
  var title = $('input[name="product-title"]').val();
  var description = $('textarea[name="product-description"]').val();

  //var saveDefaultTitle = executeOrCallSuccessCallbackDecorator(saveDefaultTitleOrDescription, useDefaultTitle);
  //var saveDefaultDescription = executeOrCallSuccessCallbackDecorator(saveDefaultTitleOrDescription, useDefaultDescription);

  // saveDefaultTitle('title', title, activeDocument.product.id, function () {
  //   saveDefaultDescription('description', description, activeDocument.product.id, function () {
      $.ajax({
        type: "POST",
        url: Editor.pageURL,
        data: {
          user_data: JSON.stringify(activeDocument.userData),
          selected_variant: data.selected,
          disable_variants: data.disableVariants,
          disable_options: JSON.stringify(collectDisableOptionData()),
          user_variants: JSON.stringify(data.userVariants),
          tags: $("#tag-list-block p").map(function () {
            return $(this).data("value");
          }).get(),
          markup: $("#MarkupVal input").val(),
          title: /*useDefaultTitle ? null :*/ title,
          description: /*useDefaultDescription ? null :*/ description,
          chosen_colors: activeDocument.chosenColors,
          update_fields: activeDocument.updateFields
        },
        dataType: "json",
        cache: false,
        success: function (result) {
          Editor.activeDocument.documentChanged = false;
          if (result.status === "error") {
            hideOverlay();
            showToastErrorMessage(result.message);
          } else {
            window.location = Editor.listURL;
          }
        },
        error: function (response) {
          var result = response.responseJSON;
          hideOverlay();
          showToastErrorMessage(errorMessage(result));
        },
        complete: function () {
          hideOverlay();
        }
      });
    // });
  // });
};

var layerComponents = null;
var userImage = null;
var layerComponentsLoadCancelObj = null;
var background = null;
var canvas = null;
var ctx = null;
var btx = null;
var slider = null;

var scope = {
  imageId: null,
  image: null,
  preview: null,
  scale: 1,
  flipHorizontal: false,
  rotationDegrees: 0,
  translateX: 0,
  translateY: 0

  // synced - if back side image settings are same as front side image settings

  // translateX, translateY are values in the product print image coord system
  // NOT the canvas coord system.
};

var activeDocument = null;
var initialLoadInaProgress = false;
var inLoading = false;

// -------------------------------------------------------------------------------------------------------------------//
Editor.pageURL = null;
Editor.listURL = null;

function collectDisableOptionData() {
  var optionData = {};
  $('.show-categories input:not(:checked)').each(function (index) {
    var objKey = $(this).data('id');
    var objValue = $(this).data('value');
    if (!optionData[objKey])
      optionData[objKey] = [];
    optionData[objKey].push(objValue);
  });
  //console.log(optionData);
  return optionData;
}

function collectSelectedVariants() {
  var selectedVariants = [];
  $(".variants input[id^='variant-'][data-id]:checked").each(function (index) {
    var variantId = $(this).data('id');
    selectedVariants.push(variantId);
  });
  return selectedVariants;
}

// DOMREADY //
Editor.init = function (cfg, listURL, pageURL) {
  config = cfg;
  if ($("canvas").length == 0) {
    return;
  }

  Editor.pageURL = pageURL;
  Editor.listURL = listURL;

  background = $("#image-editor-canvas-background")[0];
  canvas = $("#image-editor-canvas-foreground")[0];
  ctx = canvas.getContext("2d");
  btx = background.getContext("2d");

  slider = document.getElementById("editor-slider");
  if (slider) {
    noUiSlider.create(slider, {
      start: 1,
      orientation: 'horizontal',
      connect: [false, true],
      direction: 'ltr',
      step: 0.05,
      tooltips: [{
        to: function (value) {
          return Math.round(value * 100) + "%";
        },
        from: function (value) {
          return value.replace('%', '') / 100;
        }
      }],
      range: {
        'min': 0, //.05,
        'max': 2
      },
      pips: {
        mode: 'count',
        //values: [0,0.5,1,1.5,2],
        values: 5,
        density: 5,
        /*stepped: true,*/
        format: {
          to: function (value) {
            return ""; //Math.round(value*100) + "%";
          },
          from: function (value) {
            return value;
          }
        }
      }
    });
    slider.noUiSlider.on('slide', function () {
      Editor.onScaleChange({data: {value: slider.noUiSlider.get()}});
    });
    var connect = slider.querySelectorAll('.noUi-connect');
    var classes = ['c-1-color', 'c-2-color'];
    for (var i = 0; i < connect.length; i++)
      connect[i].classList.add(classes[i]);

    $(".scale-plus").on("click", Editor.onScalePlusClick);
    $(".scale-minus").on("click", Editor.onScaleMinusClick);

    $("#image-editor-canvas-foreground").on("mousemove", Editor.onMouseMove);
    $("#image-editor-canvas-foreground").on("mousedown", Editor.onMouseDown);
    $("#image-editor-canvas-foreground").on("mouseup", Editor.onMouseUp);
  }

  $("#action-rotate").on("click", Editor.onButtonRotateClick);
  $("#action-mirror").on("click", Editor.onToggleSideClick);
  $("#action-center-h").on("click", Editor.onResetTX);
  $("#action-center-v").on("click", Editor.onResetTY);
  $("#more-images").on("click", Editor.onImagesGallery);

  $("#action-next-image").on("click", Editor.onNextImage);
  $("#action-prev-image").on("click", Editor.onPrevImage);

  $('input[name="product-title"], textarea[name="product-description"]').change(function () {
    Editor.activeDocument.documentChanged = true;
  });
  $('input[name="use-title-as-default"], input[name="use-description-as-default"]').change(function () {
    Editor.activeDocument.documentChanged = true;
  });

  $("#side-selector button").on("click", Editor.changeSideClick);

  $("#enable-all-colors").on("change", activateAllColors);
  $("#colors-panel label").on("click", activateColor);
  $("#enable-all-variants").on("change", activateAllVariants);
  $("#variants-panel .imageModelsName").on("click", activateVariant);
  $("#colors-panel input, #variants-panel input").on('change', onUpdateVariant);

  $("#share-all-settings").on("change", Editor.changeShareClick);
  $("#sync-back-side").on("change", Editor.changeSyncBackSideClick);
  $("#MarkupVal input").on("input", Editor.markupChange);
  $("#shipping-selector").on("selectmenuchange", Editor.onShippingTabChange);
  $("#variant-pricing-link").on("click", Editor.showVariantPricingTable);

  $('.js-images-list').on("click", "a", function ($event) {
    $event.preventDefault();

    $('.js-images-list .active').removeClass("active");
    $(this).addClass("active");

    replaceImage({
      id: $(this).data('imageId'),
      image: $(this).data('imageSrc'),
      preview: $(this).data('imagePreview')
    });
  });


  $("#image-delete").on("click", function ($event) {
    $event.preventDefault();
    if (Editor.onFileChanged)
      Editor.onFileChanged(null);
  });

  $("#file-uploader").on("change", function ($event) {
    if (Editor.onFileChanged)
      Editor.onFileChanged($(this).prop('files'));
  });

  $("#action-upload-image").click(function ($event) {
    $event.preventDefault();
    if ($("#file-uploader").prop('files').length === 0) {
      $("#file-uploader").click();
    } else {
      Editor.uploadImg($("#file-uploader").prop('files'));
    }
  });

  Editor.uploadImg = function (files) {
    Editor.onFileChanged(files);
  };

  $("#editor-save-button").on("click", function ($event) {
    $event.preventDefault();
    saveScope();

    if (activeDocument.product.customizable && !activeDocument.userData["front"].imageId && !activeDocument.userData["back"].imageId) {
      showToastErrorMessage("Please upload image at least on one side!");
      return;
    }

    var activeVariants = false;
    var activeVariantsIsSelected = false;
    for (var i = 0; i < activeDocument.variants.length; i++)
      if (+activeDocument.variants[i].status) {
        activeVariants = true;
        if (activeDocument.variants[i].id == activeDocument.selectedVariant.id)
          activeVariantsIsSelected = true;
        break
      }
    if (!activeVariants) {
      showToastErrorMessage("Please select at least one variant!");
      return;
    }
    // if (!activeVariantsIsSelected) {
    //     editorErrorMessage("Please select a default variant!");
    //     return;
    // }

    /** Checking on unchecked all options(for example unchecked all options in Size or Gender parts) */
    var valid = true;
    $('.show-categories').each(function (index) {
      if ($(this).find("input").length > 0 && $(this).find('input:checked').length === 0) {
        valid = false;
        showToastErrorMessage("Please select at least one option for - " + $(this).data("key"));
      }
    });
    if (!valid)
      return;

    /** Check correct amount of product variants start */

    var selectedColors = [];

    $("#colors-choice-panel input:checked").each(function (index) {
      var colData = $(this).data('id');
      selectedColors.push(colData);
      activeDocument.documentChanged = true;
    });

    var updateFields = [];
    $('.dropdown.update-fields input:checked').each(function (index) {
      updateFields.push($(this).val());
    });
    activeDocument.updateFields = updateFields;

    //
    showOverlay();
    $.ajax({
      type: "POST",
      url: Editor.pageURL + '/calculate',
      data: {
        selected_variants: collectSelectedVariants(),
        disable_options: JSON.stringify(collectDisableOptionData()),
        has_back: +(activeDocument.product.has_back && activeDocument.userData.back.image !== null && activeDocument.userData.front.image !== null)
      },
      dataType: "json",
      success: function (result) {
        //console.log(result);

        if (result.success === false && result.service === 'shopify') {
          showToastErrorMessage("The number of product variants is limited to 100.\n"
            + "Amount selected variants are " + result.value);
          return;
        }

        if (result.success === false && result.service !== 'shopify') {
          showToastErrorMessage("Amount selected variants are " + result.value);
          return;
        }

        // TODO: ETSY only!
        // if (result.showChoiceWindow) {
        //     if (activeDocument.product.has_back && activeDocument.userData.back.image && activeDocument.userData.front.image) {
        //         $("#choice-variant-popup .back-use").removeClass('hidden');
        //         $("#choice-variant-popup .back-not-use").addClass('hidden');
        //     } else {
        //         $("#choice-variant-popup .back-use").addClass('hidden');
        //         $("#choice-variant-popup .back-not-use").removeClass('hidden');
        //     }
        //     $("#choice-variant-popup").prepareDialog();
        //     $("#choice-variant-popup").dialog("open");
        //     var html = '';
        //     $('.settingsBlock .checkbox-color input:checked').each(function (index) {
        //         var id = $(this).data('id');
        //         var name = $(this).parent().find('.hintInfo').text();
        //         var color = $(this).parent().find('label').css('background-color');
        //         var isChecked = activeDocument.selectedVariant.id === id || result.chosen.indexOf(String(id)) !== -1 ? 'checked' : '';
        //         html += '<div class="checkbox-color">\n' +
        //             '   <input type="checkbox" id="variant-color-' + id +'" class="checkboxColor choiceColor" ' + isChecked + ' name="variant['+ id +']" value="1" data-id="' + id + '">\n' +
        //             '       <label class="-hint_anchor" style="background-color: ' + color + ';" for="variant-color-' + id + '">\n' +
        //             '           <i class="glyphicon glyphicon-ok"></i><div class="hintInfo -small" style="font-weight: normal">' + name + '</div>\n' +
        //             '       </label>\n' +
        //             '</div>';
        //
        //     });
        //     $("#choice-variant-popup .dialog-body .colors-list").empty();
        //     $("#choice-variant-popup .dialog-body .colors-list").append(html);
        //     return;
        // }

        if (selectedColors.length > 0) {
          activeDocument.chosenColors = selectedColors;
        }

        if (activeDocument.documentChanged) {
          confirmRequest(
            "Do you really want to save your changes?",
            "Saving confirmation", "Save changes", "Cancel",
            function () {
              if (Editor.onDocumentSaved !== null) {
                Editor.onDocumentSaved();
              }
            }
          );
        } else {
          window.location = Editor.listURL;
        }

      },
      complete: function () {
        hideOverlay();
      }
    });
    /** Check correct amount of product variants end */
  });

  $("#action-delete-image").on("click", function ($event) {
    $event.preventDefault();
    scope.imageId = null;
    scope.image = null;
    scope.preview = null;
    saveScope();
    showVersion(activeDocument.selectedVariant, activeDocument.side);
  });

  $('.show-categories').on("click", "p input", function () {
    activeDocument.documentChanged = true;
  });

  $("#itemImage .itemImageEdit").on("click", function ($event) {
    // Old code. No such dialog at moment
    //$event.preventDefault();
    //openModal("#rename-image");
    //Editor.$item = null;
    //$("#rename-image").find("input[name=name]").val(na).focus().select();
  });

  $("#tag-list-block").on("click", "p a", function ($event) {
    $event.preventDefault();
    $(this).closest('p').remove();

    activeDocument.documentChanged = true;
  });

  var tagTemplate = $(".js-template").show().remove();
  //<p class="js-template" style="display: none;" data-value=""><span class="txt"></span><a href="#"></a></p>

  $("#add-tag-button").on("click", function ($event) {
    $event.preventDefault();

    var sType = $(this).data('service');

    var tag = $("#add-tag-input").val().trim();

    if (tag.trim() == "") {
      $("#add-tag-input").val("");
      return;
    }

    var re = new RegExp('[^A-Za-z0-9& \\-_\\\']', 'g');
    if (tag.match(re) || ['-', '&', '_', '\''].indexOf(tag) >= 0) {
      showToastErrorMessage("Tag should contain only Latin letters and numbers");
      return;
    }

    tag = tag.replace(re, '');
    if (tag.trim() == "")
      return;

    var T_LIMIT = {
      shopify: 30,
      woocommerce: 30,
      etsy: 20
    };

    if (tag.length > T_LIMIT[sType]) {
      showToastErrorMessage("Tag cannot be longer than " + T_LIMIT[sType] + " characters");
      return;
    }
    if ($("#tag-list-block p").length >= 13) {
      showToastErrorMessage("Number of tags is limited - 13");
      return;
    }

    $("#add-tag-input").val("");

    var tags = $("#tag-list-block p").map(function () {
      return $(this).data("value").toLocaleLowerCase();
    }).get();
    if (tags.indexOf(tag.toLocaleLowerCase()) < 0) {
      var $tg = tagTemplate.clone();
      $tg.find(".txt").text(tag);
      $tg.data("value", tag);
      $("#tag-list-block").append($tg);

      activeDocument.documentChanged = true;
    } else {
      showToastErrorMessage("You may not have duplicate tags");
      return;
    }

    $("#add-tag-input")[0].focus();
  });

  $("#add-tag-input").on("keypress", function ($event) {
    var keycode = ($event.keyCode ? $event.keyCode : $event.which);
    if (keycode == "13") {
      $event.preventDefault();
      $("#add-tag-button").trigger("click");
    }
  });

  initCanvasSize();
  $(window).on("resize", initCanvasSize);

  $("#choice-variant-popup").on("dialogclose", function (event) {
    $("#choice-variant-popup .colors-list").empty();
  });

  $(".dropdown.update-fields dt a").on("click", function () {
    $(".dropdown dd ul").slideToggle("fast");
  });

  $(".dropdown.update-fields dd ul li a").on("click", function () {
    $(".dropdown.update-fields dd ul").hide();
  });

  function getSelectedValue(id) {
    return $("#" + id).find("dt a span.value").html();
  }

  $(document).click(function (e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("dropdown")) $(".dropdown.update-fields dd ul").hide();
  });

  $('.multi-select input[type="checkbox"]').on('click', function () {
    activeDocument.documentChanged = true;

    var //title = $(this).closest('.multi-select').find("input[type="checkbox"]').val(),
      title = $(this).val();
    var upcTitle = title.substr(0, 1).toLocaleUpperCase() + title.substr(1);
    var editSection = '.edit-' + title;
    if ($(this).is(':checked')) {
      $(editSection).removeClass('hide');
      if (title == 'tags') {
        $('#tag-list-block a').removeClass('hide');
        $('#tag-list-block p').addClass('deletable');
      }
      var text = $('.selected-field > span').length > 0 ? ", " + upcTitle : upcTitle;
      var html = '<span title="' + upcTitle + '">' + text + '</span>';
      $('.selected-field').append(html);
      $(".non-select").hide();
    } else {
      $(editSection).addClass('hide');
      if (title == 'tags') {
        $('#tag-list-block a').addClass('hide');
        $('#tag-list-block p').removeClass('deletable');
      }
      $('.selected-field span[title="' + upcTitle + '"]').remove();
      $('.selected-field > span:first-child').text($('.selected-field > span:first-child').text().replace(", ", ""));

      if ($('.multi-select input[type="checkbox"]:checked').length == 0) {
        $(".non-select").removeClass('hide').show();
      }

    }
  });
};

// -------------------------------------------------------------------------------------------------------------------//

function imageURL(path, type) {
  type = type || "layers";
  var url = path ? ((path.indexOf("://") >= 0 ? "" : (config[type])) + path) : null;
  return url;
}

function getVariantTemplate(templateId) {
  for (var i = 0; i < activeDocument.templates.length; i++) {
    if (activeDocument.templates[i].id == templateId)
      return activeDocument.templates[i];

  }
  throw new Error("Unknown template " + templateId);
  return null;
}

function getLayerComponents(readyCallback) {
  var templateOBJ = activeDocument.activeTemplate[activeDocument.side];
  //console.log("templateOBJ", templateOBJ);

  var imagesToLoad = [];
  if (templateOBJ.background) {
    imagesToLoad.push(imageURL(templateOBJ.background, "layers"));
  }
  if (templateOBJ.foreground) {
    imagesToLoad.push(imageURL(templateOBJ.foreground, "layers"));
  }
  if (templateOBJ.mask) {
    imagesToLoad.push(imageURL(templateOBJ.mask, "layers"));
  }

  //for (var i = 0; i < imageVariant.masks.length; ++i) {
  //    imagesToLoad.push(imageURL(imageVariant.masks[i].mask));
  //}

  imagePreloader.load(imagesToLoad, function (images) {
    if (templateOBJ.background) {
      templateOBJ.backgroundImg = images[imageURL(templateOBJ.background, "layers")];
    }

    if (templateOBJ.foreground) {
      templateOBJ.foregroundImg = images[imageURL(templateOBJ.foreground, "layers")];
    }

    if (templateOBJ.zoneWidth) {
      templateOBJ.maskZone = {
        width: templateOBJ.zoneWidth,
        height: templateOBJ.zoneHeight,
      }
    }
    else if (templateOBJ.mask) {
      templateOBJ.maskImg = images[imageURL(templateOBJ.mask, "layers")];
    }
    templateOBJ.maskInfo = {
      left: templateOBJ.maskLeft,
      top: templateOBJ.maskTop,
      width: templateOBJ.maskWidth,
      height: templateOBJ.maskHeight
    }

    /*for (var i = 0; i < imageVariant.masks.length; ++i) {
        imageVariant.masks[i].mask =
            images[imageURL(imageVariant.masks[i].mask)];
    }*/

    readyCallback(templateOBJ);
  });

}

function drawImage(ctx, img, fitOrFill, x, y, fitWidth, fitHeight, centre, tx, ty, scale,
                   flipHorizontal, rotationDegrees) {
  if (!img) {
    return;
  }

  ctx.save();
  var hRatio = fitWidth / img.width;
  var vRatio = fitHeight / img.height;
  var ratio = fitOrFill == "fit" ? Math.min(hRatio, vRatio) : Math.max(hRatio, vRatio);

  var w = img.width * ratio * scale;
  var h = img.height * ratio * scale;

  var xoff = Math.round(x + tx + (centre ? ((fitWidth - w) / 2) : 0));
  var yoff = Math.round(y + ty + (centre ? ((fitHeight - h) / 2) : 0));

  ctx.translate(xoff + w / 2, yoff + h / 2); // Set the origin to the center of the image
  if (flipHorizontal) {
    ctx.scale(-1, 1);
  }

  ctx.rotate(rotationDegrees * (Math.PI / 180));
  ctx.drawImage(img, -w / 2, -h / 2, w, h);
  ctx.restore();
}

function getScaledEnclosingQuad(canvas, maskSize, maskInfo) {
  var hRatio = canvas.width / maskSize.width;
  var vRatio = canvas.height / maskSize.height;
  var scale = Math.min(hRatio, vRatio);

  // flip coord system too as pillow in python is opposite to html5 canvas
  var xoff = (canvas.width - (maskSize.width * scale)) / 2;
  var yoff = (canvas.height - (maskSize.height * scale)) / 2;
  var quad = {
    bottom_left: [xoff + +maskInfo.left * scale, yoff + (+maskInfo.top + +maskInfo.height) * scale],
    bottom_right: [xoff + (+maskInfo.left + +maskInfo.width) * scale, yoff + (+maskInfo.top + +maskInfo.height) * scale],
    top_left: [xoff + +maskInfo.left * scale, yoff + +maskInfo.top * scale],
    top_right: [xoff + (+maskInfo.left + +maskInfo.width) * scale, yoff + +maskInfo.top * scale]
  };
  quad.width = Math.abs(quad.bottom_right[0] - quad.top_left[0]);
  quad.height = Math.abs(quad.bottom_right[1] - quad.top_left[1]);
  return quad;
}

function prepareMoreImages() {
  if (activeDocument.filteredImages.length > 0) {
    $('.js-productImageList a').removeClass('image');
    for (let i = 0; i < activeDocument.filteredImages.length; i++) {
      $('.js-productImageList a#image_' + activeDocument.filteredImages[i].id).addClass('image');
    }
    $("#more-images").show();
  } else {
    $("#more-images").hide();
  }
}

function loadProductImageLayerComponents() {
  prepareMoreImages();

  ///$('.productCustomization').css('visibility', 'visible');
  $('#editorCanvas').css('background-image', '');
  $("#action-next-image").hide();
  $("#action-prev-image").hide();

  if (layerComponentsLoadCancelObj) {
    // cancel any previous load request
    layerComponentsLoadCancelObj.cancel();
  }

  cancelObj.cancelled = false;

  Editor.loading = true;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  btx.clearRect(0, 0, canvas.width, canvas.height);
  layerComponents = null;
  userImage = null;

  __readyU = false;
  __readyLC = false;
  result = [];

  //console.log("SCOPE", scope);

  imagePreloader.load(imageURL(scope.image, "images"), onLoadedUserImage);
  getLayerComponents(onLoadedLayerComponents);
  layerComponentsLoadCancelObj = cancelObj;
}

function onLoadedLayerComponents(res) {
  if (res) {
    result[0] = res;
    __readyLC = true;
    checkTemplateReady();
  }
}

function getFilteredImages() {
  activeDocument.filteredImages = [];
  let variants = collectSelectedVariants();
  for (let i = 0; i < activeDocument.images.length; i++) {
    if (activeDocument.images[i].locked) {
      activeDocument.filteredImages.push(activeDocument.images[i]);
    } else {
      for (let j = 0; j < variants.length; j++) {
        if (activeDocument.images[i].variants.indexOf(variants[j]) >= 0) {
          activeDocument.filteredImages.push(activeDocument.images[i]);
          break;
        }
      }
    }
  }
  $('.none-customizable-product-images-paginator').html('');
  if (activeDocument.filteredImages.length > 1) {
    activeDocument.filteredImages.forEach(function() {
      $('.none-customizable-product-images-paginator').append('<li></li>')
    })
    $('.none-customizable-product-images-paginator li').click(function() {
      Editor.setProductBGImage($('.none-customizable-product-images-paginator li').index($(this)));
    })
  }
}

function prepareImageViewer() {
  $("#more-images").hide();
  activeDocument.imageIndex = 0;

  if (activeDocument.filteredImages.length > 0) {
    ///$('.productCustomization').css('visibility', 'hidden');
    Editor.setProductBGImage(activeDocument.imageIndex);
  } else {
    $('#editorCanvas').css('background-image', '');
  }
  $('#action-next-image, #action-prev-image').toggle(activeDocument.filteredImages.length > 1);
  onTemplateReady([null, null]);
}

Editor.onNextImage = function($event) {
    $event.preventDefault();

    activeDocument.imageIndex++;
    if (activeDocument.imageIndex >= activeDocument.filteredImages.length)
        activeDocument.imageIndex = 0;

    Editor.setProductBGImage(activeDocument.imageIndex);
};

Editor.onPrevImage = function($event) {
    $event.preventDefault();

    activeDocument.imageIndex--;
    if (activeDocument.imageIndex < 0)
        activeDocument.imageIndex = activeDocument.filteredImages.length - 1;

    Editor.setProductBGImage(activeDocument.imageIndex);
};

Editor.setProductBGImage = function(imageIndex) {
  $('#editorCanvas').css('background-image', 'url(' + config["product_images"] + activeDocument.filteredImages[imageIndex].image + ')');
  $('.none-customizable-product-images-paginator li.active').removeClass('active')
  $('.none-customizable-product-images-paginator li:eq(' + imageIndex + ')').addClass('active')
}

Editor.onImagesGallery = function($event) {
    $event.preventDefault();
    $('.js-productImageList a').eq(0).trigger('click');
};

function onLoadedUserImage(res) {
  //console.log(res);
  //if (res) {
  result[1] = res;
  __readyU = true;
  checkTemplateReady();
  //}
}

function checkTemplateReady() {
  if (__readyLC && __readyU)
    onTemplateReady(result);
}

function onTemplateReady(results) {
  if (cancelObj.cancelled) {
    return;
  }

  if (activeDocument.product.has_back && activeDocument.activeTemplate && activeDocument.activeTemplate.back) {
    $("#side-selector").show();
    $("#side-sync").show();
  } else {
    $("#side-selector").hide();
    $("#side-sync").hide();
  }

  //if (activeDocument.hasSizeChart) {
  //    $("#size-chart").attr("href", activeDocument.hasSizeChart);
  //    $("#size-chart").show();
  //}
  //else {
  //    $("#size-chart").hide();
  //}

  layerComponents = results[0];
  userImage = results[1];

  if (slider)
    canvas.style.cursor = "move";
  Editor.loading = false;
  render();

  if (scope.image && scope.image != "") {
    $("#itemImage").removeClass("-style_noImage");
    $("#itemImage .photo-preview").css("background-image", 'url(' + imageURL(scope.preview, 'images') + ')');
    $("#itemImage .photo-preview a.magnific").attr("href", imageURL(scope.image, 'images'));
  } else {
    $("#itemImage").addClass("-style_noImage");
  }

  if (cancelObj == layerComponentsLoadCancelObj) {
    layerComponentsLoadCancelObj = null;
  }
}

function render() {
  //noUi-handle

  if (!Editor.loading && layerComponents != null) {
    if (background.width == 0 || background.height == 0) {
      background.width = background.offsetWidth;
      background.height = background.offsetHeight;
      setTimeout(render, 20);
      return;
    }
    if (canvas.width == 0 || canvas.height == 0) {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      setTimeout(render, 20);
      return;
    }

    var w = canvas.width;
    var h = canvas.height;

    btx.clearRect(0, 0, w, h);
    ctx.clearRect(0, 0, w, h);

    if (activeDocument.product.customizable && userImage) {
      var maskZone = layerComponents.maskImg || layerComponents.maskZone || layerComponents.backgroundImg;
      var quad = getScaledEnclosingQuad(canvas, maskZone, layerComponents.maskInfo);
      if (layerComponents.maskImg) {
        drawImage(ctx, layerComponents.maskImg, "fit", 0, 0, w, h, true, 0, 0, 1, false, 0);
      } else if (layerComponents.maskZone) {
        ctx.fillStyle = '#0000FF';
        ctx.fillRect(quad.top_left[0], quad.top_left[1], quad.width, quad.height);
      }
      ctx.globalCompositeOperation = "source-in";

      var tx = toCanvasCoordinateSystem(canvas, scope.translateX, maskZone, layerComponents.maskInfo);
      var ty = toCanvasCoordinateSystem(canvas, scope.translateY, maskZone, layerComponents.maskInfo);

      //console.log("ROTATION", scope.rotationDegrees, "FLIP", scope.flipHorizontal);

      drawImage(ctx, userImage, "fit", quad.top_left[0],
        quad.top_left[1], quad.width, quad.height, true,
        tx, ty, parseFloat(scope.scale), !!+scope.flipHorizontal,
        -parseInt(scope.rotationDegrees)
      );

      // if (layerComponents.mask) {
      //  ctx.globalCompositeOperation = "source-over";
      // }
      ctx.globalCompositeOperation = "source-over";
      ctx.strokeStyle = activeDocument.activeTemplate[activeDocument.side].frameColor || "rgba(252,221,45,0.7)";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(quad.bottom_left[0], quad.bottom_left[1]);
      ctx.lineTo(quad.bottom_right[0], quad.bottom_right[1]);
      ctx.lineTo(quad.top_right[0], quad.top_right[1]);
      ctx.lineTo(quad.top_left[0], quad.top_left[1]);
      ctx.closePath();
      ctx.stroke();
    }

    ctx.globalCompositeOperation = "source-over";
    if (layerComponents.foreground) {
      if (activeDocument.activeTemplate[activeDocument.side].blendMode === "multiply") {
        ctx.globalCompositeOperation = "multiply";
        drawImage(ctx, layerComponents.foregroundImg, "fit", 0, 0, w, h, true, 0, 0, 1, false, 0);
        ctx.globalCompositeOperation = "source-over";
      } else {
        drawImage(ctx, layerComponents.foregroundImg, "fit", 0, 0, w, h, true, 0, 0, 1, false, 0);
      }
    }

    btx.globalCompositeOperation = "source-over";

    drawImage(btx, layerComponents.backgroundImg, "fit", 0, 0, w, h, true, 0,
      0, 1, false, 0);

    if (+activeDocument.activeTemplate.colorOverlay && activeDocument.activeTemplate[activeDocument.side].mode !== "plan") {
      btx.globalCompositeOperation = "source-in";
      btx.fillStyle = activeDocument.selectedVariant.color;
      btx.fillRect(0, 0, w, h);
    }

    if (activeDocument.activeTemplate.back) {
      if (__tRender)
        clearTimeout(__tRender);
      __tRender = setTimeout(renderSmall, 50);
    } else if (inLoading)
      completeRender();
  }
}

function completeRender() {
  inLoading = false;
  //$.LoadingOverlay("hide", true);
}

function renderSmall() {
  __tRender = null;

  var pngUrl = canvas.toDataURL('image/png');
  $(".control-" + activeDocument.side).css("background-image", "url('" + pngUrl + "')");
  var pngBaseUrl = background.toDataURL('image/png');
  $(".control-" + activeDocument.side + "-base").css("background-image", "url('" + pngBaseUrl + "')");

  //console.log("TRENDER", initialLoadInaProgress);

  if (initialLoadInaProgress) {
    initialLoadInaProgress = false;
    showVersion(activeDocument.selectedVariant, "front");
    return;
  }

  if (inLoading && activeDocument.side === "front")
    completeRender();
}

function initCanvasSize() {
  canvas.width = canvas.offsetWidth;
  canvas.height = canvas.offsetHeight;
  background.width = canvas.offsetWidth;
  background.height = canvas.offsetHeight;
  render();
}

function toPrintImageCoordinateSystem(coord) {
  var maskZone = layerComponents.maskImg || layerComponents.maskZone || layerComponents.backgroundImg;
  var quad = getScaledEnclosingQuad(canvas, maskZone, layerComponents.maskInfo);
  //var scale = activeDocument.activeTemplate[activeDocument.side].assetWidth / quad.width;
  var scale = maskZone.width / quad.width;
  return scale * coord;
}

function toCanvasCoordinateSystem(canvas, coord, maskZone, maskInfo) {
  var quad = getScaledEnclosingQuad(canvas, maskZone, maskInfo);
  //var scale = quad.width / activeDocument.activeTemplate[activeDocument.side].assetWidth;
  var scale = quad.width / maskZone.width;
  return Math.round(scale * coord);
}

/*function updateName(name)
{
    scope.userImageName = obj.userImageName;
    $("#image-name").text(scope.userImageName);
}*/

function replaceImage(obj) {
  scope.imageId = obj.id;
  scope.image = obj.image;
  scope.preview = obj.preview;
  saveScope();
  showVersion(activeDocument.selectedVariant, activeDocument.side);
}

function showVersion(variant, side) {
  activeDocument.selectedVariant = variant;
  activeDocument.activeTemplate = variant.layer_id ? getVariantTemplate(variant.layer_id) : null;
  var price = (activeDocument.selectedVariant.price !== null) ? Number(activeDocument.selectedVariant.price) : Number(activeDocument.product.price);

  if (activeDocument.product.customizable && activeDocument.product.has_back && activeDocument.activeTemplate && activeDocument.activeTemplate.back) {
    $("#PriceVal").text(round2(price / activeDocument.rate) + ' + ' + round2(variant.price_back / activeDocument.rate));
  } else {
    $("#PriceVal").text(round2(price / activeDocument.rate));
  }

  $(".FrontPriceVal").text(round2(price / activeDocument.rate));

  var userData = (typeof variant.userData !== "undefined") ? variant.userData : activeDocument.userData;
  var sides = 0;
  var hasBackImage = false;

  if (typeof userData.front.image !== "undefined" && userData.front.image !== null) {
    sides++;

    if (scope.synced) {
      sides++;
    }
  }

  if (!scope.synced && typeof userData.back.image !== "undefined" && userData.back.image !== null) {
    sides++;
    hasBackImage = true;
  }

  activeDocument.hasBothSides = (sides === 1) ? false : true;
  activeDocument.hasBackImage = hasBackImage;
  /* Update Additional cost in left part No Image field */
  $("#additional_cost_image").text(round2(variant.price_back / activeDocument.rate));
  Editor.markupChange(null);

  if (side == null) {
    inLoading = true;

    // INITIAL LOAD! - disabled - we don't have mini-pics anymore!
    /*if (activeDocument.activeTemplate.back) {
        initialLoadInaProgress = true;
        showVersion(variant, "back");
        return;
    }*/
    side = "front";
  }

  activeDocument.side = side;

  //if (variant.size_chart) {
  //    activeDocument.hasSizeChart = imageURL(variant.size_chart, "size_charts");
  //} else if (activeDocument.product.sizeChart) {
  //    activeDocument.hasSizeChart = activeDocument.product.sizeChart;
  //}

  if (activeDocument.activeTemplate
    && typeof activeDocument.activeTemplate.template === "string"
    && activeDocument.activeTemplate.template.length > 0) {
    $("#template-download")
      .attr("href", imageURL(activeDocument.activeTemplate.template, "templates"))
      .attr("download", activeDocument.product.title + "." + activeDocument.activeTemplate.template.split('.').pop())
      .show();
    //$("#template-no-file").hide();
  } else {
    $("#template-download").hide();
    //$("#template-no-file").show();
  }

  Editor.backSide = activeDocument.side !== "front";

  loadScope();

  $("#side-selector button").removeClass("active");
  $("#side-selector .side-" + activeDocument.side).addClass("active");

  getFilteredImages();
  if (activeDocument.activeTemplate) {
    loadProductImageLayerComponents();
  } else {
    prepareImageViewer();
  }

  $('.js-images-list .active').removeClass("active");

  if (scope.imageId) {
    const activeImg = $(`.js-images-list #img${scope.imageId}`);
    if (activeImg) {
      $('.collection-images .current-img').show().css('background-image', activeImg.css('background-image'));
      activeImg.addClass('active');
    } else {
      $('.collection-images .current-img').hide();
    }
  } else {
    $('.collection-images .current-img').hide();
  }

}

Editor.showDocument = function (product, variants, templates, images, userData, selectedVariantId, rate) {
  var side = side || "front";

  Editor.activeDocument =
    activeDocument = {};
  activeDocument.rate = rate;
  activeDocument.product = product;
  activeDocument.variants = variants;
  activeDocument.templates = templates;
  activeDocument.images = images;
  activeDocument.userData = userData;
  activeDocument.side = null;
  activeDocument.documentChanged = false;
  activeDocument.orgSelectedVariantId = selectedVariantId;
  activeDocument.hasColors = activeDocument.variants[0].color != "";

  // can_share_image -

  if (!activeDocument.product.can_customize_variant || variants.length < 2) {
    $(".share-enabler").hide();
  } else {
    $(".share-enabler").show();
  }

  var selectedVariant = variants[0];

  for (var i = 0; i < variants.length; i++) {

    if (variants[i].id == selectedVariantId) {
      selectedVariant = variants[i];
    }

  }
  $("#colors-panel input:not(:checked):first, #variants-panel input:not(:checked):first").trigger("change");
  activeDocument.documentChanged = false;

  showVersion(selectedVariant, null);
};

function onUpdateVariant($event) {
  var checked = $(this).prop("checked");
  if (!checked) {
    $("#enable-all-variants").prop('checked', false);
    $("#enable-all-colors").prop('checked', false);
  } else {
    if ($("#variants-panel input").not(":checked").length == 0) {
      $("#enable-all-variants").prop('checked', true);
    }
    if ($("#colors-panel input").not(":checked").length == 0) {
      $("#enable-all-colors").prop('checked', true);
    }
  }
  var variantId = $(this).data('id');

  activeDocument.documentChanged = true;

  getFilteredImages();
  if (!activeDocument.activeTemplate) {
    prepareImageViewer();
  } else {
    prepareMoreImages();
  }

  for (var i = 0; i < activeDocument.variants.length; i++) {
    if (+activeDocument.variants[i].id === +variantId) {
      activeDocument.variants[i].status = checked ? 1 : 0;
      return;
    }
  }
}

function activateColor($event) {
  var $input = $(this).parent().find("input");
  if ($(this).hasClass("selected")) {
    return;
  }

  $("#colors-panel label").removeClass("selected");
  $(this).addClass("selected");
  var variantId = $input.data('id');

  for (var i = 0; i < activeDocument.variants.length; i++) {
    if (+activeDocument.variants[i].id === +variantId) {
      if (+activeDocument.variants[i].status) {
        $event.preventDefault();
      }
      saveScope();
      showVersion(activeDocument.variants[i], null);
      return;
    }
  }
}

function activateAllColors($event) {
  $("#colors-panel input").prop('checked', $(this).prop("checked"));
  $("#colors-panel input").trigger("change");
}

function activateVariant($event) {
  $event.preventDefault();
  $("#variants-panel .imageModelsItem").removeClass("selected");
  var $item = $(this).closest('.imageModelsItem');
  $item.addClass("selected");

  var variantId = $item.find('input').data('id');
  for (var i = 0; i < activeDocument.variants.length; i++) {
    if (+activeDocument.variants[i].id === +variantId) {
      saveScope();
      showVersion(activeDocument.variants[i], activeDocument.side);
      return;
    }
  }
}

function activateAllVariants($event) {
  $("#variants-panel input").prop('checked', $(this).prop("checked"));
  $("#variants-panel input").trigger("change");
}

// function getScrollbarSize()
// {
//     if ($(document).height() > $(window).height()) {
//         if (_scrollDataX.scrollbarSize === undefined) {
//             var a = document.createElement("div");
//             a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
//             document.body.appendChild(a);
//             _scrollDataX.scrollbarSize = a.offsetWidth - a.clientWidth;
//             document.body.removeChild(a);
//         }
//         return _scrollDataX.scrollbarSize;
//     }
//     return 0;
// }

var imagePreloader = {

  // expose list of images that were created to facilitate the load for unit testing
  // purposes
  images: null,

  /*
   * Preloads an array of image url strings (or a single image url string not in an
   * array). Returns a promise that will resolve to an object who's keys are the image
   * urls strings and values are the Image objects or if a single url string was
   * passed as an argument then resolves to a single Image.
   */
  load: function (imagesToLoad, onLoad) {
    imagePreloader.images = [];

    var resolveAsSingleImage = false;
    if (imagesToLoad == null || typeof (imagesToLoad) == "string") {
      if (!imagesToLoad) {
        // Blank image
        setTimeout(onLoad, 20);
        return;
      }
      imagesToLoad = [imagesToLoad];
      resolveAsSingleImage = true;
    }

    var results = {};
    var remainingImagesToLoad = imagesToLoad.length;
    for (var i = 0; i < imagesToLoad.length; ++i) {
      (function (src) {
        var image = new Image();
        image.crossOrigin = "";
        image.src = src;
        imagePreloader.images.push(image);

        $(image).on("load", function () {
          results[src] = image;
          if (--remainingImagesToLoad == 0) {
            onLoad(resolveAsSingleImage ? image : results);
          }
        });

        $(image).on("error", function () {
          console.error(this);
          onLoad(null);
        });
      })(imagesToLoad[i]);
    }
  }
};

var cancelObj = {
  cancelled: false,
  cancel: function () {
    this.cancelled = true;
  }
};

window.Editor = Editor;
